import { render, staticRenderFns } from "./before-buy.vue?vue&type=template&id=6af81025&scoped=true&"
import script from "./before-buy.vue?vue&type=script&lang=ts&"
export * from "./before-buy.vue?vue&type=script&lang=ts&"
import style0 from "./before-buy.vue?vue&type=style&index=0&id=6af81025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af81025",
  null
  
)

export default component.exports